<mat-toolbar class="ori-elevation-z4 header">
  <mat-icon class="icon-left" svgIcon="comment"></mat-icon>
  <h3>{{ currentStepTitle | translate }}</h3>
  <mat-icon class="icon icon-close" (click)="close()" color="primary" svgIcon="close"></mat-icon>
</mat-toolbar>

<mat-stepper linear #stepper animationDuration="0ms" (selectionChange)="onStepChange($event)">
  @let forms = [senderForm, receiverForm];
  @for (form of forms; track $index) {
    <mat-step [stepControl]="form">
      <form [formGroup]="form">
        <div class="form-row required">
          <!-- company field -->
          <mat-form-field class="flex-field">
            @let company = "comments.ddn.company" | translate;
            <mat-label>{{ company }}</mat-label>
            <input matInput formControlName="entrepriseName" title="entreprise name" maxlength="50" />
            <mat-error>{{ "form.error.required" | translate: { field: company } }}</mat-error>
          </mat-form-field>
          <!-- cageCode field -->
          <mat-form-field class="fixed-field">
            @let cageCodeCtrl = form.get("cageCode");
            @let cageCode = "comments.code.cageCode" | translate;
            @let characters = "form.characters" | translate;
            <mat-label>{{ cageCode }}</mat-label>
            <input matInput formControlName="cageCode" title="cage code" maxlength="5" />
            @if (cageCodeCtrl.hasError("required")) {
              <mat-error>{{ "form.error.required" | translate: { field: cageCode } }}</mat-error>
            }
            @if (cageCodeCtrl.hasError("pattern")) {
              <mat-error>{{
                "form.error.pattern" | translate: { field: cageCode, nbrChar: "5", typeChar: characters }
              }}</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-row">
          <!-- email field -->
          <mat-form-field class="flex-field">
            <mat-label>{{ "comments.ddn.email" | translate }}</mat-label>
            <input matInput type="email" formControlName="email" title="email" maxlength="50" />
            <mat-error>{{ "form.error.email" | translate }}</mat-error>
          </mat-form-field>
          <!-- phone field -->
          <mat-form-field class="fixed-field">
            @let phone = "comments.ddn.phone" | translate;
            @let numbers = "form.numbers" | translate;
            <mat-label>{{ phone }}</mat-label>
            <input matInput type="tel" formControlName="phone" title="phone" maxlength="15" />
            <mat-error>{{
              "form.error.size" | translate: { field: phone, min: 0, max: 15, typeChar: numbers }
            }}</mat-error>
          </mat-form-field>
        </div>
        <!-- street field -->
        <mat-form-field class="full-field">
          <mat-label>{{ "comments.ddn.street" | translate }}</mat-label>
          <input matInput formControlName="street" title="street" maxlength="100" />
        </mat-form-field>
        <div class="form-row">
          <!-- city field -->
          <mat-form-field class="flex-field">
            <mat-label>{{ "comments.ddn.city" | translate }}</mat-label>
            <input matInput formControlName="city" title="city" maxlength="50" />
          </mat-form-field>
          <!-- postal field -->
          <mat-form-field class="fixed-field">
            <mat-label>{{ "comments.ddn.postal" | translate }}</mat-label>
            <input matInput formControlName="postal" title="postal" maxlength="15" />
          </mat-form-field>
        </div>
        <div class="form-row">
          <!-- state field -->
          <mat-form-field class="flex-field">
            <mat-label>{{ "comments.ddn.state" | translate }}</mat-label>
            <input matInput formControlName="state" title="state" maxlength="50" />
          </mat-form-field>
          <!-- country field -->
          <mat-form-field class="flex-field">
            <mat-label>{{ "comments.ddn.country" | translate }}</mat-label>
            <input matInput formControlName="country" title="country" maxlength="50" />
          </mat-form-field>
        </div>

        <div class="step-actions">
          <button [class.hide]="!$index" mat-raised-button matStepperPrevious type="button">
            {{ "comments.ddn.back" | translate }}
          </button>
          <button mat-raised-button matStepperNext color="primary" type="button" [disabled]="!form.valid">
            {{ "comments.ddn.next" | translate }}
          </button>
        </div>
      </form>
    </mat-step>
  }
  <mat-step [stepControl]="remarkForm">
    <form [formGroup]="remarkForm">
      <!-- code field -->
      <div class="comment-code">
        <div class="comment-code-input">
          @let codeProperties = ["model", "senderIdent", "receiverIdent", "year", "seqNumber"];
          @for (codeProperty of codeProperties; track $index) {
            <div>
              <div class="hint-top">{{ "comments.code." + codeProperty | translate }}</div>
              <input matInput [formControlName]="codeProperty" maxlength="5" />
            </div>
          }
        </div>
        <div class="comment-code-errors">
          @let seqNumberCtrl = remarkForm.get("seqNumber");
          @let field = "comments.code.seqNumber" | translate;
          @let typeChar = "form.numbers" | translate;
          @if (seqNumberCtrl.hasError("required")) {
            <mat-error>{{ "form.error.required" | translate: { field } }}</mat-error>
          }
          @if (seqNumberCtrl.hasError("pattern")) {
            <mat-error>{{ "form.error.pattern" | translate: { field, nbrChar: "5", typeChar } }}</mat-error>
          }
        </div>
      </div>
      <!-- remarks field -->
      <mat-form-field class="full-field">
        <textarea matInput formControlName="remarks" name="remarks" cdkTextareaAutosize title="remarks"></textarea>
        <mat-label>{{ "comments.ddn.remarks" | translate }}</mat-label>
      </mat-form-field>

      <div class="step-actions">
        <button mat-raised-button matStepperPrevious type="button">
          {{ "comments.ddn.back" | translate }}
        </button>
        <button
          mat-raised-button
          matStepperNext
          color="primary"
          type="submit"
          [disabled]="!remarkForm.valid"
          (click)="submit()">
          {{ "comments.ddn.confirm" | translate }}
        </button>
      </div>
    </form>
  </mat-step>
</mat-stepper>
